const initialState = {
    records: {},
    pages: 0,
    count: 0,
    documentRecords:[]
}
export const queue = (state = initialState, action) => {
    switch (action.type) {
        case "LIST_QUEUE": // to temp store records and total docs 
            return { ...state, records: action?.data?.docs, count: action?.data?.totalDocs, pages: action?.data?.totalPages };
      
        case "LIST_DOCUMENT_IN_QUEUE": // to temp store records and total docs 
            return { ...state, documentRecords: action?.data};  
        case "LOAD_QUEUE": // to temp store records and total docs 
            if (action.data)
                state.records = [...state.records, ...action?.data?.docs]
            return { ...state };
        case "UPDATE_QUEUE": // to temp store records and total docs 
            if (action.data) {
               state.records = state.records.map(x => (x._id === action.data._id ? { ...action.data } : x))

            }
            return { ...state };
        case "REMOVE_DOCUMENT": // to temp store records and total docs 
            if (action.data) {
                let documentRecords = state.documentRecords;
                let docList = documentRecords.filter(item => {
                    if (item._id != action.data._id) {
                        return item;
                    }

                });
                return { ...state, documentRecords: docList };
            }
            return { ...state };
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};
